//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import registerButtons from "@/components/auth/registerButtons";
export default {
  name: "formAuth",
  components: {registerButtons},
}
